import React, { useContext, useEffect } from 'react'; //eslint-disable-line
import { useTranslation } from 'react-i18next';
// import goTrackerConfig from 'goTrackerConfig';

const TagItem = props => {
  const { t } = useTranslation();
  const coachCountTag = ` ${t('tags.coach')}`;
  return (
    <div className={`tag-item ${props.fullWidth ? 'full-width' : ''}`}>
      <div><span className={props.blink ? 'tag-item-blink' : null}>{props.value}</span> { coachCountTag }</div>
    </div>
  );
};


export default TagItem;
